// export const BASE_URL = "https://api.impsguru.com/";
export const BASE_URL = "https://api.biggbrains.com/";
// export const BASE_URL = "https://api.dillipay.com/";
// export const BASE_URL = "http://192.168.1.14/impsguru-php/";
// export const BASE_URL = "https://api.vdeepay.com";
const ApiEndpoints = {
  CHAT_SEND:"chat/chat/send",
  CHAT_SEND_FILE:"chat/chat/send-file",
  CHAT_LONG_POLL:"chat/chat/long-poll",
  CHAT_STATUS:"chat/chat/status",
  CHAT_READ:"chat/chat/read",
  
  COOKIE: "sanctum/csrf-cookie",
  SIGN_IN: "auth/signIn",
  GET_LOGIN_HISTORY: "users/loginHistory",
  LOGOUT: "auth/logOut",
  GET_FILES: "user/getFile",
  GET_SCHEME: "schemes/getScheme",
  GET_PROJECTS: "projects/getProjects",
  DELETE_PROJECT: "projects/deleteProject",
  UPDATE_PROJECT: "projects/updateProject",
  CREATE_PROJECT: "projects/createProject",
  EDIT_SUPER_RATE: "admin/updateSuperRate",
  GET_UTILITY_SCHEME: "schemes/utilitySchemes",
  GET_DMT_SCHEMA: "schemes/dmtSchemes",
  GET_PAYOUT_SCHEMA: "schemes/payoutSchemes",
  AGEMENT_DATE: "admin/aggreementDate",
  SEND_OTP_Okyc: "user/sendOtpOkyc",
  VERIFY_OTP_OKYC: "user/verifyOtpOkyc",
  GET_NEWS: "admin/news",
  LOGIN_OTP_VALIDATE: "auth/secureLogin",
  GET_ME_USER: "auth/getUser",
  FORGOT_PASS: "auth/forgetPassword",
  RESET_MPIN: "auth/resetMpinByUsername",
  CHANGE_PASS: "auth/changePassword",
  CHANGE_MPIN: "auth/changeMpin",
  OBTAIN_DOCS: "auth/getDocs",
  GET_RECENT_DATA: "reports/recentHistory",
  GET_USERS: "admin/getUsers",
  GET_USERS_ACC: "",
  VERIFY_PIC: "admin/approveRejectKyc",
  PAYOUT_BENES: "admin/payoutBene",
  PAYOUT_BENE_KYC_DOCS: "admin/beneKycDoc",
  GET_USER_BY_USERNAME: "auth/getUserByUsername",
  UPDATE_USER_PROFILE:"profile/updateProfile",
  UPLOAD_PROFILE_IMG:"user/uploadProfileImg",
  GET_USER_BY_ID: "admin/getUserById",
  UPDATE_USER: "admin/updateUser",
  RESEND_OTP: "wallet/resendOtp",
  USER_PROFIT: "admin/userProfitability",
  DELETE_USER: "admin/deleteUser",
  API_USERS_CHARGES: "admin/charges",
  ADMIN_PRABHU_CHARGES: "admin/psrabhuCharge",
  API_USERS_KEYS: "admin/userKeys",
  BLOCK_UNBLOCK: "admin/blockUnblock",
  GET_SALARY: "salary/getSalary",
  ADD_SALARY: "salary/addSalary",
  EDIT_SALARY: "salary/editSalary",
  DELETE_SALARY: "salary/deleteSalary",
  GET_TRANSACTIONS: "admin/getTransactions",
  GET_ACC_TRANSACTIONS: "",
  GET_TRANSACTIONS: "admin/getTransactions",
  CRED_REQ: "admin/getCrRequests",
  CRED_REQ_APPROVE: "admin/crActions",
  GET_OPERATOR: "admin/getOperators",
  ACTIVE_INACTIVE_OPERATOR: "admin/changeOperatorStatus",
  UPDATE_OPERATOR: "admin/updateOperator",
  ADD_OPERATOR: "admin/createOperator",
  ADD_BANK: "admin/createBank",
  CHANGE_ROUTE_OPERATOR: "admin/changeRoute",
  CHANGE_OPERATOR_PIPE: "admin/changePipe",
  GET_ROUTE: "admin/getRoutes",
  GET_CATEGORIES: "admin/getCategories",
  GET_ACCOUNTS: "admin/getAccounts",
  GET_ACC_ACCOUNTS: "",
  GET_BANKS: "admin/getBanks",
  GET_ACC_BANKS: "",
  UPDATE_BANKS: "admin/changeBankStatus",
  ADD_ACCOUNT: "admin/createNewAcc",
  ADD_ACCOUNT_TXN: "admin/addAccTxn",
  DELETE_TXN: "admin/deleteTxn",
  GET_MASSEGE: "admin/getMessages",
  GET_OUT_MASSEGE: "admin/getOutMessages",
  GET_WEBHOOK: "admin/getWebHooks",
  GET_ACCOUNT_STATEMENT: "admin/getAccStatement",
  GET_BANK_STATEMENT: "admin/getBankStatement",
  ADD_BANK_TXN: "admin/addBankTxn",
  DELETE_BANK_TXN: "admin/deleteBankTxn",
  GET_PENDING_ACCOUNT_TRANSACTION: "admin/getPendingBankTxn",
  GET_STATUS: "admin/checkTxnStatus",
  CHANGE_STATUS: "admin/changeTxnStatus",
  UPDATE_ACCOUNT: "admin/updateAccounts",
  GET_PLANS: "admin/getPlans",
  BLOCK_UNBLOCK_PLANS: "",
  ADD_PLAN: "admin/createPlan",
  DELETE_PLAN: "admin/deletePlan",
  COMPLAINTS: "admin/getIssues",
  GET_USER_AD_ASM: "admin/getUserAdAsm",
  GET_NOTIFICATION: "admin/getNotifications",
  MARK_READ_NOTI: "admin/updateNotification",
  ADMIN_OP_SERVICE: "admin/service",
  VERIFY_PAN: "admin/verifyPan",
  ADMIN_PG_ORDERS: "admin/pgOrders",
  VERIFY_AADHAAR: "admin/verifyAadhaar",
  TWOFA_AUTH: "auth/twoFactorAuthentication",
  WALLET_DEBIT: "/admin/walletDebit",
  CREATE_VA: "admin/createVa",
  VIRTUAL_ACCS: "admin/virtualAccounts",
  VIRTUAL_TRANSACTIONS: "admin/vaTransactions",
  BANK_DETAILS: "admin/bankDepData",
  SEND_OTP: "user/sendOtp",
  GET_API_TOKEN: "user/getApiToken",
  GET_API_KEY: "user/getApiKey",
  RESET_API_TOKEN: "user/resetApiToken",
  RESET_API_KEY: "user/resetApiKey",
  GET_TASK: "tasks/getTasks",
  GET_TASK_ID: "tasks/getTasks",
  EDIT_TASK: "tasks/editTask",
  EDIT_TASK1: "tasks/editTask1",
  MERCHANT_RESPONSE: "tasks/merchantResponse",
  ASIGN_TO_TASK: "tasks/optTask",
  CREATE_TASK: "tasks/createTask",
  // REG user
  USER_REG: "wallet/userRegistration",
  USER_PERSONALINFO: "wallet/addPersonalInfo",
  USER_BUSINESSINFO: "wallet/addBusinessInfo",
  GET_DISTRICTS: "prepaid/getDistricts",
  GET_STATES: "getStates",
  GET_HANDLER_DETAILS: "auth/getUserByUsername",
  VERIFY_MOBILE: "auth/verifyMobile",
  SIGN_UP_LAST: "aeps/initiateSignup",
  GET_USERROLES: "onboarding/userOnboarding",

  // Admin employees
  EMPLOYEES: "/emp/getEmployee",
  ADD_EMPLOYEES: "emp/createEmp",
  EDIT_EMPLOYEES: "emp/updateEmp",

  OTP_EXP: "dmr/otpExp",
  OTP_dmt1: "dmr/transactionOtpDmt1",
  GET_TIME: "https://timeapi.io/api/time/current/zone?timeZone=Asia%2FKolkata",
  GET_USERS_BIGG: "users/getUsers",
  GET_USER_BIGG: "users/getUser",
  CREATE_USERS_BIGG: "users/createUser",
  UPDATE_USERS_BIGG: "users/updateUser",
  DELETE_USERS_BIGG: "users/deleteUser",
  GET_UTILS: "misc/getUtils",
  CREATE_UTILS: "misc/createUtil",
  DELETE_UTILS: "misc/deleteUtil",
  UPDATE_UTILS: "misc/updateUtil",
  GET_PROFILE: "misc/getFile",
  GET_DASHBOARD_DATA: "misc/getDashboardData",
  CHANGE_PASSWORD: "auth/changePassword",
  DO_ATTENDANCE: "attendance/inAttendance",
  OUT_ATTENDANCE: "attendance/outAttendance",
  GET_ATTENDANCE: "attendance/getAttendance",
  GET_PROJECT_NAME: "projects/getProjectNames",
  GET_USERS_NAME: "users/getUsersForFilter",
  Add_Leave: "leave/leaveRequest",
  GET_LEAVE: "leave/getLeaveRequests",
  TOTAL_LEAVE: "leave/getLeave",
  UPDATE_LEAVE: "leave/updateLeaveRequest",
  CREATE_LEAVE: "leave/createLeave",
  DELETE_LEAVE: "leave/deleteLeave",
  DELETE_TASK: "tasks/deleteTask",
  UPDATE_DEVELOPER_LEAVE: "leave/updateLeave",
  GET_ASSET: "asset/getAsset",
  CREATE_ASSET: "asset/createAsset",
  UPDATE_ASSET: "asset/updateAsset",
  GET_INVOICES: "invoice/getInvoices",
  GENERATE_INVOICE: "invoice/generateInvoice",
  UPDATE_INVOICE: "invoice/editInvoice",
  RANDOM_INVOICE_NO: "invoice/getInvNo",
  DELETE_INVOICE: "invoice/deleteInvoice",
  UPDATE_EMPLOYEE: "profile/updateProfileByAdmin",
  GET_SALES_ATTENDANCE: "attendance/getSalesAttendance",
  DELETE_SALES_ATTENDANCE: "attendance/deleteVisit",
  SCHEDULE_ROASTER: "users/roaster",
  GET_USERS_FOR_BACKEND: "users/getUsersForBackend",
  PUNISHED_LEAVE: "leave/deductLeave",
  EARN_COMPENSATORY_LEAVE: "leave/earnCompensatoryRequest",
  GET_PAYROLL_COMPONENT: "/payroll/components",
  CREATE_PAYROLL_COMPONENT: "/payroll/createComponent",
  UPDATE_PAYROLL_COMPONENT: "/payroll/updateComponent/{id}",
  DELETE_PAYROLL_COMPONENT: "/payroll/deleteComponent/{id}",

  ASSIGN_SALARY: "payroll/assignSalary",
  GET_EMPLOYEE_SALARY: "payroll/getEmployeeSalary", 

  GENERATE_SALARY_SLIP: "payroll/generateSalarySlip",
  GET_SALARY_SLIPS: "payroll/getSalarySlips",
  GET_SALARY_SLIP: "payroll/getSalarySlip",

  GET_SALARY: "payroll/salaries", 
  ADD_SALARY: "payroll/assignSalary",
  DELETE_SALARY: "payroll/deleteSalary", 
  GET_EMPLOYEES_FOR_SALARY: "payroll/employees-without-salary", 










};
export default ApiEndpoints;
